import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Form } from "react-bootstrap";
import BaseModal from "./BaseModal";
import SearchSelect from "../../components/forms/SearchSelect";
import { fetchAllRoles } from "../../redux/slice/getRolesPermissionListSlice";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeList } from "../../redux/slice/getEmployeeListSlice";

const EditRoleModal = ({
  show,
  onHide,
  setShowEditRoleModal,
  employeeData,
  onUpdate,
  canEdit,
}) => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange"
  });
  const { roles } = useSelector(state => state.rolePermission);
  const [pageSize] = useState(20);
  useEffect(() => {
    if (show) {
      reset({ roleId: "" });
    }
  }, [show, reset]);
  useEffect(() => {
    dispatch(fetchAllRoles());
  }, []);

  const roleOptions = roles?.map((item) => ({
    value: item.roleId,
    label: item.roleName,
  }));

  const onSubmit = async (data) => {
    if (!canEdit) {
      toast.error("You do not have permission to update role!", { className: 'toast-error-custom', autoClose: 5000 });
      return;
    }
    if (employeeData) {
      const userId = employeeData.userId;
      const roleId = data.roleId;
      await dispatch(onUpdate({ userId, roleId }));

      setShowEditRoleModal(false);
      dispatch(fetchEmployeeList({ page: 1, SB: "", order: "", size: pageSize }));
    }
  };

  const footerButtons = (
    <>
      <Button variant="cancel-cta" onClick={() => setShowEditRoleModal(false)}>
        Cancel
      </Button>
      <Button
        variant="update-cta"
        type="submit"
        form="edit-role-form"
        disabled={!isValid || !canEdit}
      >
        Update
      </Button>
    </>
  );

  return (
    <BaseModal
      show={show}
      onHide={onHide}
      title="Edit Employee Role"
      footerButtons={footerButtons}
    >
      <Form id="edit-role-form" onSubmit={handleSubmit(onSubmit)}>
        <Form.Group className="mb-3" controlId="empName">
          <Form.Label>Employee Name</Form.Label>
          <Form.Control
            type="text"
            value={employeeData?.fullName || ""}
            disabled
            readOnly
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="currentRole">
          <Form.Label>Current Role</Form.Label>
          <Form.Control
            type="text"
            value={employeeData?.roleName || ""}
            disabled
            readOnly
          />
        </Form.Group>
        <SearchSelect
          name="roleId"
          label="New role *"
          options={roleOptions}
          rules={{ required: "Role is required" }}
          placeholder="Please select the new role"
          disabled={!canEdit}
          control={control}
          errors={errors}
        />
      </Form>
    </BaseModal>
  );
};

export default EditRoleModal;

EditRoleModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  setShowEditRoleModal: PropTypes.func.isRequired,
  employeeData: PropTypes.shape({
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fullName: PropTypes.string,
    roleName: PropTypes.string,
  }),
  onUpdate: PropTypes.func.isRequired,
  canEdit: PropTypes.bool
};

// Default props for non-required fields
EditRoleModal.defaultProps = {
  canEdit: false,
  employeeData: null
};